module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "fjqk350y",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
